@if (toasts().length) {
  <div class="toast-host" aria-live="polite" aria-relevant="additions">
    @for (item of toasts(); track item.id) {
      <div
        class="toast"
        [class]="'toast toast--' + item.kind"
        [attr.role]="item.kind === 'error' ? 'alert' : 'status'"
      >
        <span class="toast__icon" aria-hidden="true">
          @if (item.kind === 'success') {
            <span class="toast__sparkle toast__sparkle--tl"></span>
            <span class="toast__sparkle toast__sparkle--tr"></span>
            <span class="toast__dot"></span>
            <span class="toast__badge">
              <app-icon name="check" [size]="14" [strokeWidth]="2.8" />
            </span>
          } @else {
            <app-icon [name]="iconFor(item.kind)" [size]="16" [strokeWidth]="2.2" />
          }
        </span>

        @if (item.kind === 'success') {
          <span class="toast__rule" aria-hidden="true"></span>
        }

        <div class="toast__body">
          <span class="toast__title">{{ item.message }}</span>
          @if (item.description || item.action) {
            <span class="toast__desc">
              @if (item.description) {
                {{ item.description }}
              }
              @if (item.action; as action) {
                <button type="button" class="toast__action" (click)="runAction(item, action)">
                  {{ action.label }}
                  <app-icon name="chevronRight" [size]="13" [strokeWidth]="2.4" />
                </button>
              }
            </span>
          }
        </div>

        <button
          type="button"
          class="toast__close"
          [attr.aria-label]="'Dismiss notification'"
          (click)="dismiss(item)"
        >
          <app-icon name="close" [size]="14" [strokeWidth]="2.2" />
        </button>
      </div>
    }
  </div>
}
